import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts: any[] = [];

  show(type: 'success' | 'error' | 'warning' | 'info', message: string) {
    // Prevent redundant toasts of the same type and message
    const isDuplicate = this.toasts.some(t => t.type === type && t.message === message && !t.removing);
    if (isDuplicate) {
      return;
    }

    const id = 'toast-' + Date.now();
    const toast = { id, type, message, removing: false };

    this.toasts.push(toast);

    setTimeout(() => this.dismiss(id), 5000);
  }

  dismiss(id: string) {
    const toast = this.toasts.find(t => t.id === id);
    if (toast) {
      toast.removing = true;
      setTimeout(() => {
        this.toasts = this.toasts.filter(t => t.id !== id);
      }, 300);
    }
  }
}
